import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceLocal {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  Page(message: string) {
    this.pageChange.next(message)
  }

  signUpUser(req: any) {
    return this.networkService.post("api/connection/form", req, null, null);
  }
  verifyEamilExist(req: any){
    return this.networkService.post("api/user/verify", req, null, null);
  }
  emailCheck(req: any) {
    return this.networkService.post("api/connection/form/v3", req, null, null);
  }
  createOtp(req: any){
    return this.networkService.post("api/otp/create", req, null, null);
  }
  verifyOtp(req: any){
    return this.networkService.post("api/otp/verify", req, null, null);
  }
  signup(req: any){
    return this.networkService.post("api/user", req, null, null);
  }
  validateLogin(req: any) {
    return this.networkService.login("api/admin/login", req, null, null);
  }

  forgotPassword(req: any) {
    return this.networkService.post("api/user/forgotPassword", req, null, null);
  }
  verifyEmail(body:any) {
    return this.networkService.post("api/user/verify",body, null,null);
  }
  resetpassword(req: any) {
    return this.networkService.post("api/user/verify/password/forgot", req, null, null);
  }
  getUserProfile(Id:any) {{{URL}}
    return this.networkService.get("api/user/fullprofile/v3?"+Id, null, null);
  }

  submitCandidateAssessment(req: any) {
    return this.networkService.post("api/userassessment/candidate/submit", req, null, null);
  }
  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("image",image);
    return this.networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }

}
